import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraButton, SpecraInput } from '@mono/ui-components/ensigns';
import { SpecraFormField, SpecraInlineBanner, SpecraPopover } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { projectDataClient } from '../../../../lib/connect/clients';
import { usePricingWrite } from './usePricingRateBook';
export function EscalationPopover({ scope, token, value, anchor, onClose }) {
    const [pct, setPct] = useState(String(value * 100));
    const [batchId] = useState(()=>crypto.randomUUID());
    const write = usePricingWrite(()=>projectDataClient.patchPricingScenario({
            projectId: scope.projectId,
            scenarioId: scope.scenarioId,
            expectedUpdatedAt: token,
            clientBatchId: batchId,
            ops: [
                {
                    op: 'set',
                    path: '/rateCard/escalation/defaultPct',
                    valueJson: JSON.stringify(Number(pct) / 100)
                }
            ]
        }));
    return /*#__PURE__*/ _jsxs(SpecraPopover, {
        open: true,
        anchor: anchor,
        onOpenChange: (v)=>{
            if (!v) onClose();
        },
        "aria-label": "Escalation",
        children: [
            /*#__PURE__*/ _jsx(SpecraFormField, {
                label: "Escalation (%/yr)",
                htmlFor: "escalation-pct",
                children: /*#__PURE__*/ _jsx(SpecraInput, {
                    id: "escalation-pct",
                    "data-testid": Testids.pricingWorkspace.escalation,
                    inputMode: "decimal",
                    value: pct,
                    onChange: (e)=>setPct(e.target.value)
                })
            }),
            /*#__PURE__*/ _jsx(SpecraButton, {
                disabled: !pct.trim() || !Number.isFinite(Number(pct)) || write.isPending,
                onClick: async ()=>{
                    try {
                        await write.mutateAsync();
                        onClose();
                    } catch  {
                    /* inline */ }
                },
                children: "Save"
            }),
            write.error && /*#__PURE__*/ _jsx(SpecraInlineBanner, {
                tone: "danger",
                children: write.error.message
            })
        ]
    });
}
